module.exports = __webpack_public_path__ + "img/taxserviceTxt.4b9d18f7.png";